import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useDefaultProject } from './useDefaultProject'

export const useDefaultFolder = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const defaultProjectQuery = useDefaultProject(currentWorkspaceId)
  return defaultProjectQuery?.data?.project
}
